export default {
  getSupplyHistory: {
    method: 'post',
    url: '/client/supply/history/list'
  }
}
